/* eslint-disable @next/next/no-img-element */
import React from 'react'
import Image from 'next/image'
import Head from 'next/head'
import { OrganizationJsonLd } from 'next-seo'
import useCMS from '../../hooks/useCMS'
import Layout from '../../components/Layout'

export default function About() {
  return (
    <>
      <Head>
        <title key="title">
          Lets grow your channel together | Tube Transcripts
        </title>
        <link
          rel="canonical"
          href="https://www.tubetranscripts.com/about"
          key="canonical"
        />
        <meta
          property="og:url"
          content="https://www.tubetranscripts.com/about"
          key="og-url"
        />
      </Head>
      <OrganizationJsonLd
        type="Corporation"
        legalName="Niche Mates LLC"
        name="Tube Transcripts"
        url="https://tubetranscripts.com"
        logo="https://www.tubetranscripts.com/android-chrome-512x512.png"
        contactPoints={[
          {
            telephone: '+4915735760905',
            contactType: 'customer service',
            availableLanguage: ['English', 'German'],
          },
        ]}
      />
      <section className="w-full bg-white">
        <div className="max-w-4xl px-2 py-10 mx-auto xl:px-0">
          <h1 className="w-full px-8 text-4xl font-extrabold text-center text-gray-800 font-body lg:text-6xl">
            The story behind Tube Transcripts
          </h1>
        </div>
        <section id="about" className="w-full pt-24 pb-32 bg-white">
          <div className="relative px-4 mx-auto lg:px-12">
            <div className="relative grid items-center grid-cols-1 gap-10 p-12 overflow-hidden shadow-2xl bg-gradient-to-r from-gray-500 to-gray-600 md:grid-cols-5 lg:gap-0 rounded-3xl">
              <div className="absolute top-0 right-0">
                <svg
                  viewBox="0 0 487 487"
                  className="object-cover w-full h-full"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M487 486.7c-66.1-3.6-132.3-7.3-186.3-37s-95.9-85.3-126.2-137.2c-30.4-51.8-49.3-99.9-76.5-151.4C70.9 109.6 35.6 54.8.3 0H487v486.7z"
                    fill="#FFF"
                    fillRule="nonzero"
                    fillOpacity=".1"></path>
                </svg>
              </div>

              <div className="absolute bottom-0 left-0 h-full">
                <svg
                  viewBox="0 0 487 487"
                  className="w-auto h-full opacity-75 object-stretch"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0 .3c67 2.1 134.1 4.3 186.3 37 52.2 32.7 89.6 95.8 112.8 150.6 23.2 54.8 32.3 101.4 61.2 149.9 28.9 48.4 77.7 98.8 126.4 149.2H0V.3z"
                    fill="#FFF"
                    fillRule="nonzero"
                    fillOpacity=".1"></path>
                </svg>
              </div>

              <div className="relative z-30 col-span-1 md:col-span-3">
                <div className="flex items-center space-x-4 md:flex-row">
                  <Image
                    src="https://yt3.ggpht.com/ytc/AAUvwnjxtricct6eAWUCD667bfL2J5DSVFkSv-0ZSu0W=s176-c-k-c0x00ffffff-no-rj"
                    alt="Matt Phelps Avatar"
                    width={120}
                    height={120}
                    objectFit="contain"
                    className="rounded-full"
                  />
                  <h2 className="mb-1 text-3xl font-bold leading-tight text-gray-100 md:mb-3 md:text-3xl lg:text-4xl xl:text-5xl">
                    Hey 👋 <span className="block lg:mt-3">I&apos;m Matt</span>
                  </h2>
                </div>
                <p className="max-w-sm my-6 text-base font-normal text-gray-200 xl:max-w-lg lg:pr-0 pr-7 lg:text-xl">
                  I grew{' '}
                  <a
                    className="underline"
                    href="https://www.youtube.com/channel/UCrhM0tPz7bFPV5I3tPF-TVw">
                    my Youtube
                  </a>{' '}
                  subscribers from 0 to 4046 in 2 months with 4 videos. The
                  average channel takes 70+ videos and 1.5 years to hit 1k!
                  <br />
                  <br />
                  How did I do it? Search Engine Optimisation, SEO. Subtitles,
                  or transcriptions, are crucial. Unforuntately, the Youtube
                  auto transcripts don&apos;t count for SEO. So I used to spend
                  hours writing them myself because I didn&apos;t want to pay
                  someone 15-20$ per video.
                  <br />
                  <br />
                  My buddies and I made this service to make it easy to get
                  cheap, fast and accurate transcriptions. To save time, money
                  and get more views!
                  <br />
                  <br />
                  If you have any questions,{' '}
                  <a
                    className="underline"
                    href="mailto:matthewguyphelps@gmail.com">
                    reach out to me
                  </a>{' '}
                  😁
                </p>
                <a
                  href="https://chrome.google.com/webstore/detail/youtube-transcripts/cijnpkfpdlieljkblckfggiiflecfmff"
                  className="flex items-center justify-center w-full px-4 py-2 mt-6 text-base font-medium leading-6 text-center text-purple-600 whitespace-no-wrap bg-white border-2 border-transparent rounded-full shadow-sm md:w-auto md:inline-flex hover:bg-transparent hover:text-white hover:border-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-700">
                  Grow Fast using SEO 🚀
                </a>
              </div>
              <div className="flex flex-col items-center justify-center h-full col-span-1 mt-4 lg:flex-row md:col-span-3 xl:col-span-2">
                <Image
                  src="/growth.png"
                  alt="YouTube growth chart"
                  width={795}
                  height={404}
                  className="rounded-2xl"
                />
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  )
}

export async function getStaticProps() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { getArticles } = useCMS()
  const articles = await getArticles()

  return {
    props: {
      articles,
    },
    revalidate: 600,
  }
}

About.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>
}

About.propTypes = {}
